export default ({}) => {
  return (
    <div className="sort-handler">↕</div>
  )
}
